import AlgbraQuoteAvatar from '@public/images/avatars/algbra-marten-moller.png'
import PayhawkQuoteAvatar from '@public/images/avatars/payhawk-customer-quote-avatar.png'
import SoldoQuoteAvatar from '@public/images/avatars/soldo-carlo-gualandri.png'
import VisaQuoteAvatar from '@public/images/avatars/visa-jeni-mundy.png'
import AlgbraQuoteImage from '@public/images/customers/tab-quotes/tab-3/algbra.png'
import PayhawkQuoteImage from '@public/images/customers/tab-quotes/tab-3/payhawk.png'
import SoldoQuoteImage from '@public/images/customers/tab-quotes/tab-3/soldo.png'
import VisaQuoteImage from '@public/images/customers/tab-quotes/tab-3/visa.png'
import AlgbraLogo from '@public/images/logos/algbra.png'
import PayhawkLogo from '@public/images/logos/payhawk.png'
import SoldoLogo from '@public/images/logos/soldo.png'
import VisaLogo from '@public/images/logos/visa.png'
import { useState } from 'react'

import TwoColumnLayoutWithTabs, { TabDetails } from '@/components/TwoColumnLayoutWithTabs'

enum Customers {
    VISA = 'Visa',
    Payhawk = 'Payhawk',
    algbra = 'algbra',
    Soldo = 'Soldo',
}

export type CustomerDetails = Record<Customers, TabDetails<Customers>>

const customerDetails: CustomerDetails = {
    Visa: {
        name: Customers.VISA,
        logo: VisaLogo,
        description: (
            <>
                Visa saw their unique opportunity to create exponentially positive climate impact
                for millions of customers and partners by making payments greener.
                <br />
                <br />
                By partnering with Lune, merchants can launch a green checkout while banks,
                fintechs, and issuers can help customers contribute to high quality climate projects
                — all using Lune’s API.
            </>
        ),
        quoteImage: VisaQuoteImage,
        quoteName: `Jeni Mundy`,
        quoteTitle: `Global SVP Merchant Sales and Acquiring at Visa`,
        quoteAvatar: VisaQuoteAvatar,
        quoteText: (
            <>
                Sustainability is a growing focus in the payment ecosystem, and we are building our
                capabilities at Visa to meet that demand. Through our partnership with Lune, we aim
                to make it easier for our clients to take meaningful climate action, by embedding
                emission calculations and carbon offsetting into their product offering.
            </>
        ),
        chips: [`emissionCalculations`, `climateProjects`],
        chipColor: `#FFD6B8`,
    },
    Payhawk: {
        name: Customers.Payhawk,
        logo: PayhawkLogo,
        description: (
            <>
                After surveying their customers using Lune’s go-to-market resources, Payhawk found
                that 85% of their customers wanted emissions visibility within their spend
                management platform. Incoming regulatory requirements is putting pressure on SMBs.
                <br />
                <br />
                Having integrated Lune&apos;s API, Payhawk automatically calculates the emissions of
                all spend and enables their SMB customers to get emissions reports in seconds.
            </>
        ),
        quoteImage: PayhawkQuoteImage,
        quoteName: `Hristo Borisov`,
        quoteTitle: `CEO at Payhawk`,
        quoteAvatar: PayhawkQuoteAvatar,
        quoteText: (
            <>
                Through speaking with our customers we learned that many wanted help understanding
                the CO₂ emissions related to their company spend. Working with Lune, we’ve brought
                that to life quickly and easily.
            </>
        ),
        chips: [`emissionCalculations`],
        chipColor: `#FFE5BA`,
    },
    algbra: {
        name: Customers.algbra,
        logo: AlgbraLogo,
        description: (
            <>
                Algbra’ is changing the banking industry to become more ethical and sustainable.
                <br />
                <br />
                In order to offer their users the highest quality carbon offsetting options, they
                use Lune to allow consumers to offset their emissions and contribute to vetted
                climate projects directly through the Algbra’ app.
            </>
        ),
        quoteImage: AlgbraQuoteImage,
        quoteName: `Marten Möller`,
        quoteTitle: `ESG Manager at Algbra`,
        quoteAvatar: AlgbraQuoteAvatar,
        quoteText: (
            <>
                Connecting our customers to high-impact projects was really important to us. After
                trying consultancies, we realised that we wanted higher quality and greater
                transparency into climate projects, and more control over the buying process. Lune
                ticked all of these boxes, making it easy for us to feel confident in the projects
                we offer our customers.
            </>
        ),
        chips: [`climateProjects`],
        chipColor: `#EEEDEB`,
    },
    Soldo: {
        name: Customers.Soldo,
        logo: SoldoLogo,
        description: (
            <>
                Soldo saw a unique opportunity to support their customers through climate
                compliance.
                <br />
                <br />
                By integrating Lune’s API, Soldo’s customers can now measure, report, and offset the
                emissions created by their business spend.
            </>
        ),
        quoteImage: SoldoQuoteImage,
        quoteName: `Carlo Gualandri`,
        quoteTitle: `Founder and CEO of Soldo`,
        quoteAvatar: SoldoQuoteAvatar,
        quoteText: (
            <>
                Soldo was founded to relieve the laborious admin created by spend management, and
                now we can do the same for emission management.
                <br />
                <br />
                By partnering with Lune we’re accelerating our commitment to customers and planet,
                simultaneously.
            </>
        ),
        chips: ['emissionCalculations', `climateProjects`],
        chipColor: `#F7C8A6`,
    },
}

const CustomersTab3 = () => {
    const [selectedCustomer, setSelectedCustomer] = useState<Customers>(Customers.VISA)

    return (
        <TwoColumnLayoutWithTabs
            values={customerDetails}
            value={selectedCustomer}
            onChange={setSelectedCustomer}
        />
    )
}

export default CustomersTab3
